import React from "react";
import { Container, Alert } from "react-bootstrap";

export interface IErrorProps {
  message? : string | undefined;
  useContainer? : boolean | undefined;
}

export const Error = ({ message, useContainer } : IErrorProps) => {
  const errorMessage = message ?? "There has been a problem with your request";
  const includeContainer = useContainer ?? true;

  return (
    includeContainer
      ? (
        <Container aria-atomic="true">
          <Alert variant="danger" className="margin-medium">
            {errorMessage}
          </Alert>
        </Container>
      )
      : (
        <Alert variant="danger" className="margin-medium">
          {errorMessage}
        </Alert>
      )
  );
};
